import { render, staticRenderFns } from "./ManifestDetailTable.vue?vue&type=template&id=51170cdb&scoped=true"
import script from "./ManifestDetailTable.vue?vue&type=script&lang=ts"
export * from "./ManifestDetailTable.vue?vue&type=script&lang=ts"
import style0 from "./ManifestDetailTable.vue?vue&type=style&index=0&id=51170cdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51170cdb",
  null
  
)

export default component.exports